import { z } from 'zod';

export const UploadUrlSchema = z.object({
  id: z.string().optional(),
  version: z.string().trim(),
  type: z.string(),
  fileName: z.string().optional().optional(),
});

export const UploadUrlSchemaRequired = UploadUrlSchema.required({
  id: true,
  version: true,
  type: true,
  fileName: true,
});
